export const infiniteScroll = () => {
    return {
        restrict: 'A',
        scope: {
            onScroll: '&',
            resetTracker: '='
        },
        link: function (scope, element, attrs) {
            let itemHeight = parseFloat(attrs.itemHeight, 10);
            let pageSize = parseInt(attrs.pageSize, 10);
            let bufferSize = parseInt(attrs.bufferSize, 10) || 0; // Default to 0 if not provided
            let containerHeight = parseInt(attrs.containerHeight, 10);
            let lastScrollTop = 0;
            let lastEmittedPageIndex = 0;

            element.on('scroll', function () {
                let scrollTop = element[0].scrollTop;
                let currentPageIndex = 0;
                const scrolledDown = scrollTop + containerHeight;

                if (bufferSize) {
                    const pageHeight = itemHeight * pageSize;
                    const scrolledFullPages = Math.floor(scrolledDown / (itemHeight * pageSize));
                    const scrolledDownSinceLastFullPage = scrolledDown - (scrolledFullPages * pageHeight);
                    const pageHeightWithoutBuffer = (pageSize - bufferSize) * itemHeight;
                    const scrolledPagesWithoutBuffer = Math.floor(scrolledDownSinceLastFullPage / pageHeightWithoutBuffer);

                    currentPageIndex = scrolledFullPages + scrolledPagesWithoutBuffer;
                } else {
                    currentPageIndex = Math.round(scrollTop / (itemHeight * pageSize));
                }

                if (scrollTop > lastScrollTop && currentPageIndex > lastEmittedPageIndex) {
                    lastEmittedPageIndex = currentPageIndex;

                    if (angular.isFunction(scope.onScroll)) {
                        scope.$apply(() => {
                            scope.onScroll({ index: currentPageIndex });
                        });
                    }
                }

                lastScrollTop = scrollTop;
            });

            scope.$watch('resetTracker', function (newVal) {
                if (newVal) {
                    lastEmittedPageIndex = 0;
                    lastScrollTop = 0;
                    element.scrollTop(0);
                    scope.resetTracker = false; // Reset the flag
                }
            });
        }
    };
};
